// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-actions-group{display:flex}.v-actions-group .v-btn:not(:first-child){margin-left:.75rem}.v-actions-group--right{justify-content:flex-end}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
